export enum HttpStatus {
    OK = 200,

    BAD_REQUEST = 400,
    UNAUTHORIZED = 401,
    FORBIDDEN = 403,
    NOT_FOUND = 404,
    METHOD_NOT_ALLOWED = 405,
    VALIDATION_ERROR = 422,

    SERVER_ERROR = 500,
}
